import { call, put, takeLatest, all } from "redux-saga/effects";
import { fetchViewCourseDefinitionApi } from "./view-course.service";
import {
    FETCH_VIEW_COURSE_DETAILS_REQUEST,
    fetchViewCourseDetailsSuccess,
    fetchViewCourseDetailsFailure,
} from "./view-course.action";

export function* fetchGeneralDetailsSaga(action: { type: string; payload: { courseDefintionID: string } }): Generator<any, void, any> {
    try {
        const response = yield call(fetchViewCourseDefinitionApi, action.payload.courseDefintionID);
         if (response?.success) {
             yield put(fetchViewCourseDetailsSuccess(response.data));
        } else {
            const message = response?.message || 'Failed to fetch general details';
            yield put(fetchViewCourseDetailsFailure(message));
        }
        } catch (error: any) {
            yield put(fetchViewCourseDetailsFailure(error?.message || 'Failed to fetch general details'));
        }
}

export default function* viewCourseSaga() {
    yield all([
        takeLatest(FETCH_VIEW_COURSE_DETAILS_REQUEST, fetchGeneralDetailsSaga),
    ]);
}